import { ApiResourceBaseClass as n } from "./baseApiCalls.js";
const s = "feedback/feedback_result";
class r extends n {
  /**
   * Searches for feedback results.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/feedback/feedback_result`
   *
   * @param {FeedbackResultQueryParams & CursorPaginationParams} queryParams
   */
  searchFeedbackResults = async (t) => {
    const { data: e } = await this.get(
      `${s}`,
      t
    );
    return e;
  };
  /**
   * Download feedback results.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/feedback/feedback_result/download`
   *
   * @param {FeedbackResultQueryParams & { email: string; feedback_form_ids: string }} queryParams
   */
  downloadFeedbackResults = async (t) => {
    const { data: e } = await this.get(`${s}/download`, t);
    return e;
  };
  /**
   * Get a reply suggestion for a feedback result.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/feedback/feedback_result/fetch-suggestion/:feedbackResultId/:index`
   *
   * @param {number} feedbackResultId - The ID of the feedback result
   * @param {number} index - The index of the reply suggestion (must be 0, 1 or 2)
   */
  getReplySuggestion = async (t, e) => {
    const { data: a } = await this.get(
      `${s}/fetch-suggestion/${t}/${e}`
    );
    return a;
  };
  /**
   * Report a reply suggestion.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/feedback/feedback_result/report-suggestion`
   *
   * @param {number} suggestionId - The ID of the reply suggestion
   */
  reportSuggestion = async (t) => {
    const { data: e } = await this.post(`${s}/report-suggestion`, {
      suggestion_id: t
    });
    return e;
  };
  /**
   * Reply to a feedback result.
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/feedback/feedback_result/:feedbackResultId/reply`
   *
   * @param {number} feedbackResultId - The ID of the feedback result
   * @param {ReplyFeedbackResultsPayload} payload
   */
  replyFeedbackResult = async (t, e) => {
    const { data: a } = await this.post(
      `${s}/${t}/reply`,
      e
    );
    return a;
  };
  /**
   * Delete a feedback result.
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/feedback/feedback_result/:feedbackResultId`
   *
   * @param {number} feedbackResultId - The ID of the feedback result
   */
  deleteFeedbackResult = async (t) => {
    const { data: e } = await this.delete(`${s}/${t}`);
    return e;
  };
}
export {
  r as FeedbackResult
};
